import React from 'react';

import mail from 'assets/images/svg/mail.svg';
import phone from 'assets/images/svg/phone.svg';
import telegram from 'assets/images/svg/telegram.svg';

import arrowImg from '../../../assets/images/arrow-yellow.png';
import { Container, Image, Section } from '../../../components';
import styles from './Contacts.module.scss';

const contacts = [
  {
    title: 'Менеджер по работе с инвестициями',
    name: 'Егор Крид',
    telegram: 'meneger',
    phone: '+7 (495) 150-16-67',
    email: 'meneger@gmail.com',
  },
  {
    title: 'Менеджер по работе с продавцами долговых требований',
    name: 'Егор Крид',
    telegram: 'meneger',
    phone: '+7 (495) 150-16-67',
    email: 'meneger@gmail.com',
  },
];
const Contacts = () => {
  return (
    <>
      <Section className={styles.section}>
        <Container>
          <div className={styles.wrap}>
            <div className={styles.left}>
              <h2 className={styles.title}>Мы открыты к сотрудничеству и всегда на связи</h2>
              <a href="tel:+74954775257" className={styles.phone}>
                +7 (495)477-52-57
              </a>

              <div className={styles.visual} aria-hidden>
                <div className={styles.bgCircle} />
                <img className={styles.arrow} src={arrowImg} alt="" />
              </div>
            </div>

            <div className={styles.right}>
              {contacts.map((item, i) => (
                <article className={styles.card} key={i}>
                  <h3 className={styles.cardTitle}>{item.title}</h3>
                  <p className={styles.cardSub}>{item.name}</p>

                  <ul className={styles.list}>
                    <li className={styles.row}>
                      <Image src={telegram} alt="" className={styles.icon} />
                      <a
                        href={`https://t.me/${item.telegram}`}
                        className={styles.link}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {item.telegram}
                      </a>
                    </li>
                    <li className={styles.row}>
                      <Image src={phone} alt="" className={styles.icon} />
                      <a href={`tel:${item.phone.replace(/[^\d+]/g, '')}`} className={styles.link}>
                        {item.phone}
                      </a>
                    </li>
                    <li className={styles.row}>
                      <Image src={mail} alt="" className={styles.icon} />
                      <a href={`mailto:${item.email}`} className={styles.link}>
                        {item.email}
                      </a>
                    </li>
                  </ul>
                </article>
              ))}
            </div>
          </div>
        </Container>
      </Section>
    </>
  );
};

export default Contacts;
